import docReady from "./docReady";
import disableOnClick from "./disable-on-click";
import initiateCountdown from "./initiate-countdown";
import lotBidSuccessRedirect from "./lotbid-success-redirect";
import messageTools from "./messageTools";
import nav from "./nav";
import payment from "./payment/payment";
import pledgePage from "./pledgePage.js";
import popupService from "./popup-service";
import textBoxValidation from "./textbox-validation";
import confirmPassword from "./confirm-password";
import InitCloseMessages from "./closeMessages";
import lotList from "./lot-list";
import InitRafflePayment from "./raffle/rafflePayment";
import toggleGiftAidTextArea from './toggleGiftAidTextArea'
import InitTicketsPayment from "./tickets/ticketsPayment";
import InitBuyItNowOrderPayment from "./buyItNowOrderPayment/buyItNowOrderPayment";

docReady.docReady(function () {
	disableOnClick.init();
	initiateCountdown.init();
	lotBidSuccessRedirect.init();
	messageTools.init();
	nav.init();
	payment.init();
	pledgePage.init();
	popupService.init();
	textBoxValidation.init();
	confirmPassword.init();
	InitCloseMessages();
	lotList.init();
	InitRafflePayment();
	InitTicketsPayment();
	toggleGiftAidTextArea.init();
	InitBuyItNowOrderPayment();
});
